export const setSelectProfileFilterValue = (value) => {
  return { type: "SET_SELECT_PROFILE_FILTER_VALUE", payload: value };
};

export const setProfileFilterCheckedItems = (value) => {
  return { type: "SET_PROFILE_FILTER_CHECKED_ITEMS", payload: value };
};